const resource = 'partners';

export default ($axios, isAdmin = false) => ({
    // GET
    getPartners(params = {}) {
        if (!isAdmin) return { data: [] };
        return $axios.get(`/${resource}`, { params });
    },
    // Requires SuperAdmin Privileges ⤵
    getPartnerById(partnerId) {
        return $axios.get(`/${resource}/${partnerId}`);
    },

    getCurrentPartner(partnerId) {
        return $axios.get(`/portal/${partnerId}/getCurrentPartner`);
    },

    validatePermissions(partnerId, params = {}) {
        return $axios.get(`/portal/${partnerId}/validatePermissions`, { params });
    },

    getDashboardComponents(params = {}) {
        return $axios.get(`/portal/getDashboardComponents`, { params });
    },
});
